import React from 'react';
import {
  ArrayField,
  ChipField,
  Create,
  Edit,
  EditButton,
  Filter,
  maxLength,
  minLength,
  ReferenceArrayInput,
  required,
  SimpleList,
  SingleFieldList,
  TextField,
  TextInput,
} from 'react-admin';
import { useMediaQuery } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import { ZippityDatagrid, ZippitySimpleForm } from '../../components';
import BulkDeleteButton from '../../components/BulkDeleteButton';
import CustomTitle from '../../components/CustomTitle';
import ReferenceArrayChild from '../../components/ReferenceArrayChild';
import { perPage } from '../../helper';
import ListWithCSVImport from '../../components/ListWithCSVImport';

const HealthCheckFilter = (props) => <Filter {...props} />;

const listStyles = {
  nb_commands: { color: 'purple' },
  primary_text: { display: 'flex', justifyContent: 'space-between' },
  primary_text_left: { width: '70%', padding: '5px' },
  primary_text_right: { width: '25%' },
  primary_hr: {
    borderColor: 'rgba(236, 236, 236, 0.25)',
    marginBottom: '15px',
    marginTop: '0',
  },
  fieldLabel: {
    fontWeight: '600',
  },
  fieldDescription: {
    marginTop: '0',
    marginBottom: '5px',
  },
};

export const HealthCheckList = withStyles(listStyles)(
  ({ classes, ...props }) => {
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    return (
      <div>
        <ListWithCSVImport
          {...props}
          filters={<HealthCheckFilter />}
          bulkActionButtons={<BulkDeleteButton />}
          sort={{ field: 'name', order: 'ASC' }}
          perPage={50}
        >
          {isSmall ? (
            <SimpleList
              primaryText={(record) => (
                <>
                  <div className={classes.primary_text}>
                    <div className={classes.primary_text_left}>
                      <span className={classes.fieldLabel}>Name: </span>
                      <p
                        className={classes.fieldDescription}
                      >{` ${record.name}`}</p>
                    </div>
                    <div className={classes.primary_text_right}>
                      <span className={classes.fieldLabel}>Created At: </span>
                      <p className={classes.fieldDescription}>{`${new Date(
                        record.created_at,
                      ).toLocaleDateString()}`}</p>
                    </div>
                  </div>
                  <hr className={classes.primary_hr} />
                </>
              )}
              secondaryText={(record) => (
                <ArrayField
                  basePath="inspections"
                  record={record}
                  label="inspections"
                  source="inspections"
                  reference="inspections"
                  linkType={false}
                >
                  <SingleFieldList>
                    <ChipField source="inspection_name" />
                  </SingleFieldList>
                </ArrayField>
              )}
              linkType={(record) => (record.canEdit ? 'edit' : 'show')}
            />
          ) : (
            <ZippityDatagrid>
              <TextField source="created_at" />
              <TextField source="modified_at" />

              <TextField source="name" />

              <ArrayField source="inspections" sortable={false}>
                <SingleFieldList>
                  <ChipField source="inspection_name" />
                </SingleFieldList>
              </ArrayField>

              <EditButton />
            </ZippityDatagrid>
          )}
        </ListWithCSVImport>
        <p>Top-level Health Checks. See Inspection for details.</p>
      </div>
    );
  },
);

const editStyles = {
  referenceArrayWide: { width: '100%' },
};

const validateRequiredString = [required(), minLength(2), maxLength(63)];

export const HealthCheckEdit = withStyles(editStyles)(
  ({ classes, ...props }) => (
    <Edit
      undoable={false}
      title={<CustomTitle title="resources.health-check.title" />}
      {...props}
    >
      <ZippitySimpleForm>
        <TextInput validate={validateRequiredString} source="name" />
        <ReferenceArrayInput
          source="inspection_ids"
          reference="inspection"
          perPage={perPage}
          className={classes.referenceArrayWide}
          sort={{ field: 'inspection_name', order: 'ASC' }}
        >
          <ReferenceArrayChild
            {...props}
            optionText="inspection_name"
            source="inspection_ids"
          />
        </ReferenceArrayInput>
      </ZippitySimpleForm>
    </Edit>
  ),
);

export const HealthCheckCreate = withStyles(editStyles)(
  ({ classes, ...props }) => (
    <Create {...props}>
      <ZippitySimpleForm>
        <TextInput validate={validateRequiredString} source="name" />
        <ReferenceArrayInput
          source="inspection_ids"
          reference="inspection"
          perPage={perPage}
          className={classes.referenceArrayWide}
          sort={{ field: 'inspection_name', order: 'ASC' }}
        >
          <ReferenceArrayChild
            {...props}
            optionText="inspection_name"
            source="inspection_ids"
          />
        </ReferenceArrayInput>
      </ZippitySimpleForm>
    </Create>
  ),
);
